import Component from "@ember/component";
import { classNames } from "@ember-decorators/component";
import ShowBackupInfo from "../../components/show-backup-info";

@classNames("before-backup-list-outlet", "discoursehosting")
export default <template><ShowBackupInfo /></template>